import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconLineArrow(props: SvgIconProps) {
  return (
    <SVGIcon width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6 11L11 6L6 1" stroke="currentColor" strokeWidth="1.5" />
      <path d="M11 6H0" stroke="currentColor" strokeWidth="1.5" />
    </SVGIcon>
  );
}
